// src/theme/breakpoints.ts
// Single source of truth for responsive breakpoints (spec §1).
// mobile <768 · tablet 768–1023 · desktop ≥1024. The 0.02px shaves avoid
// the 1px overlap between a max-width and the next min-width tier.
export const BREAKPOINTS = { mobile: 768, desktop: 1024 } as const;

export const query = {
  mobile: `(max-width: ${BREAKPOINTS.mobile - 0.02}px)`,
  tabletDown: `(max-width: ${BREAKPOINTS.desktop - 0.02}px)`,
  tabletUp: `(min-width: ${BREAKPOINTS.mobile}px)`,
  desktop: `(min-width: ${BREAKPOINTS.desktop}px)`,
} as const;

export type MediaQueryKey = keyof typeof query;
